import React from 'react';
import ReactDOM from 'react-dom/client';
import './main.css';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from "./auth/AuthProvider";
import { AppDataProvider } from "./data/AppDataProvider";

if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            registrations.forEach((registration) => {
                void registration.unregister();
            });
        }).catch((error) => {
            console.error("Service worker cleanup failed", error);
        });

        if ("caches" in window) {
            caches.keys().then((keys) => {
                keys.forEach((key) => {
                    void caches.delete(key);
                });
            }).catch((error) => {
                console.error("Cache cleanup failed", error);
            });
        }
    });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <AuthProvider>
            <AppDataProvider>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </AppDataProvider>
        </AuthProvider>
    </React.StrictMode>
);
